import { render, staticRenderFns } from "./Nosologies.vue?vue&type=template&id=6498fd39&"
import script from "./Nosologies.vue?vue&type=script&lang=js&"
export * from "./Nosologies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports